<template>
  <div class="key-user-access-wrap">
    <!-- <el-tooltip v-if="show() && status && isModuleEntry() && isShowAccess">
      <div class="custom-tooltip" slot="content">
        <span>今使用人: {{accessTotal}}</span>
        <span style="margin-left:8px">今使用率: {{accessPercent}}%</span>
      </div>
      <el-button type="text" @click.stop="handleClick">
        <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="用户评价" transform="translate(-249.000000, -94.000000)" fill="#8B60F0" fill-rule="nonzero">
                  <g id="访问" transform="translate(249.000000, 94.000000)">
                      <path d="M6,0 C2.6862,0 0,2.6862 0,6 C0,9.3138 2.6862,12 6,12 C9.3138,12 12,9.3138 12,6 C12,2.6862 9.3138,0 6,0 Z M7.8849,2.6172 C8.18064848,2.6172 8.4204,2.85695152 8.4204,3.1527 C8.4204,3.44844848 8.18064848,3.6882 7.8849,3.6882 C7.58915152,3.6882 7.3494,3.44844848 7.3494,3.1527 C7.3494,2.85695152 7.58915152,2.6172 7.8849,2.6172 L7.8849,2.6172 Z M6.1005,2.2602 C6.29181573,2.2602 6.46859875,2.36226572 6.56425662,2.52795 C6.65991448,2.69363427 6.65991448,2.89776573 6.56425662,3.06345 C6.46859875,3.22913428 6.29181573,3.3312 6.1005,3.3312 C5.80475152,3.3312 5.565,3.09144848 5.565,2.7957 C5.565,2.49995152 5.80475152,2.2602 6.1005,2.2602 L6.1005,2.2602 Z M4.1379,2.2602 C4.52400978,2.27139629 4.83120435,2.58762792 4.83120435,2.9739 C4.83120435,3.36017208 4.52400978,3.67640371 4.1379,3.6876 C3.75179022,3.67640371 3.44459565,3.36017208 3.44459565,2.9739 C3.44459565,2.58762792 3.75179022,2.27139629 4.1379,2.2602 L4.1379,2.2602 Z M6.2718,9.7398 C5.7729,9.7398 5.367,9.564 5.1288,9.2448 C4.896,8.9334 4.8402,8.5185 4.971,8.0769 C5.1393,7.509 4.9833,7.1709 4.4499,6.9471 C4.0248,6.7683 3.7326,6.3723 3.6486,5.8605 C3.5601,5.3226 3.7287,4.7754 4.0779,4.4661 C4.5681,4.032 5.2128,3.8331 6.0531,3.84 C7.7979,3.8664 8.5761,4.6893 8.5761,6.5085 C8.5758,8.562 7.7361,9.7398 6.2718,9.7398 L6.2718,9.7398 Z" id="形状"></path>
                  </g>
              </g>
          </g>
        </svg>
        <span class="label">{{accessTotal}}/{{accessPercent}}%</span>
      </el-button>
    </el-tooltip> -->


    <el-button type="text" @click.stop="handleClick"  v-if="show() && status && isModuleEntry() && isShowAccess">
      <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="用户评价" transform="translate(-249.000000, -94.000000)" fill="#6d2ef8" fill-rule="nonzero">
                <g id="访问" transform="translate(249.000000, 94.000000)">
                    <path d="M6,0 C2.6862,0 0,2.6862 0,6 C0,9.3138 2.6862,12 6,12 C9.3138,12 12,9.3138 12,6 C12,2.6862 9.3138,0 6,0 Z M7.8849,2.6172 C8.18064848,2.6172 8.4204,2.85695152 8.4204,3.1527 C8.4204,3.44844848 8.18064848,3.6882 7.8849,3.6882 C7.58915152,3.6882 7.3494,3.44844848 7.3494,3.1527 C7.3494,2.85695152 7.58915152,2.6172 7.8849,2.6172 L7.8849,2.6172 Z M6.1005,2.2602 C6.29181573,2.2602 6.46859875,2.36226572 6.56425662,2.52795 C6.65991448,2.69363427 6.65991448,2.89776573 6.56425662,3.06345 C6.46859875,3.22913428 6.29181573,3.3312 6.1005,3.3312 C5.80475152,3.3312 5.565,3.09144848 5.565,2.7957 C5.565,2.49995152 5.80475152,2.2602 6.1005,2.2602 L6.1005,2.2602 Z M4.1379,2.2602 C4.52400978,2.27139629 4.83120435,2.58762792 4.83120435,2.9739 C4.83120435,3.36017208 4.52400978,3.67640371 4.1379,3.6876 C3.75179022,3.67640371 3.44459565,3.36017208 3.44459565,2.9739 C3.44459565,2.58762792 3.75179022,2.27139629 4.1379,2.2602 L4.1379,2.2602 Z M6.2718,9.7398 C5.7729,9.7398 5.367,9.564 5.1288,9.2448 C4.896,8.9334 4.8402,8.5185 4.971,8.0769 C5.1393,7.509 4.9833,7.1709 4.4499,6.9471 C4.0248,6.7683 3.7326,6.3723 3.6486,5.8605 C3.5601,5.3226 3.7287,4.7754 4.0779,4.4661 C4.5681,4.032 5.2128,3.8331 6.0531,3.84 C7.7979,3.8664 8.5761,4.6893 8.5761,6.5085 C8.5758,8.562 7.7361,9.7398 6.2718,9.7398 L6.2718,9.7398 Z" id="形状"></path>
                </g>
            </g>
        </g>
      </svg>
      <span class="label">{{accessTotal}}/{{accessPercent}}%</span>
    </el-button>


    <el-button type="text" @click.stop="showComment" v-if="isModuleEntry() && isShowComment && !getCommentWhiteList()">
      <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 1px;">
        <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="用户评价" transform="translate(-345.000000, -94.000000)" fill="#6d2ef8">
                <g id="评价" transform="translate(345.000000, 94.000000)">
                    <path d="M6.45350293,0.23301294 C6.62539684,0.31265024 6.76345138,0.450704784 6.84308868,0.62259869 L8.11634634,3.37087408 L11.1235698,3.73255027 C11.5622364,3.78530833 11.8750771,4.18368673 11.8223191,4.62235334 C11.7996976,4.81044344 11.7110611,4.98440231 11.5721896,5.11326002 L9.7046794,6.84486502 L9.61085973,6.84524887 L9.31113396,6.84103809 L9.02073952,6.82842363 C8.87142082,6.81964018 8.73034207,6.85574369 8.61026156,6.92395331 C8.56846513,6.88437523 8.52871747,6.84886882 8.4908511,6.81731352 C8.19744076,6.5728049 7.76599698,6.59237563 7.49592839,6.86244422 C7.41405699,6.94431562 7.34538914,7.00807862 7.29195433,7.05260763 C6.99347791,7.30133798 6.9437416,7.7313414 7.1577626,8.03904846 C6.86271889,8.13435365 6.64615385,8.41127103 6.64615385,8.74208145 L6.64615385,8.74208145 L6.64615385,9.1040724 L6.6518111,9.19612434 L6.67053711,9.29324939 C6.74547458,9.57732743 6.98505977,9.79194231 7.27623838,9.83478128 L7.27623838,9.83478128 L7.31630769,9.83815385 L7.3156794,10.190865 L6.11720661,9.52359351 L3.47172379,10.9985929 C3.08582464,11.2137525 2.59857025,11.0753408 2.38341066,10.6894416 C2.29115519,10.523977 2.26061315,10.3311421 2.29722192,10.1452674 L2.88253058,7.17346381 L0.662223619,5.11326002 C0.338345286,4.81273609 0.3194128,4.30655805 0.619936727,3.98267972 C0.748794439,3.84380818 0.922753312,3.7551717 1.11084341,3.73255027 L4.11806688,3.37087408 L5.39132454,0.62259869 C5.57705587,0.221705091 6.05260934,0.0472816096 6.45350293,0.23301294 Z" id="形状结合"></path>
                    <g id="编组-7" transform="translate(7.384615, 7.384615)" fill-rule="nonzero">
                        <path d="M4.10629247,0.134899213 L4.15475113,0.180995475 L4.10629247,0.57098314 L3.6653319,0.551685312 C3.5507742,0.545833857 3.4260318,0.538086093 3.2928239,0.526733473 L3.08687783,0.50678733 L3.04072398,2.19819005 L3.85815666,2.19789345 C3.9692217,2.19838842 4.07753584,2.20073059 4.18738512,2.20896586 L4.35384615,2.22624434 L4.30481331,2.61619971 C4.16080975,2.60719949 3.99297831,2.60156916 3.80135818,2.59931651 L3.60180995,2.59819005 L3.08687783,2.5520362 L3.08717312,3.87012516 C3.08667728,3.97043154 3.08433424,4.06800849 3.07609965,4.16717211 L3.05882353,4.31764706 L2.61454343,4.26906742 C2.62256044,4.11674432 2.62790399,3.97247722 2.63057558,3.83627133 L2.63257919,3.63800905 L2.67873303,2.59819005 L2.06334842,2.59819005 C1.90115319,2.59819005 1.74575807,2.60156788 1.57648072,2.58888801 L1.40180995,2.57013575 L1.4508428,2.18018038 C1.57889219,2.18818347 1.71231809,2.19352007 1.85111811,2.19618857 L2.06334842,2.19819005 L2.63257919,2.24434389 L2.67873303,0.552941176 L2.15955165,0.553049473 C1.95592451,0.552064821 1.78695001,0.548261904 1.64659792,0.535875841 L1.54660633,0.524886878 L1.59547043,0.134899213 L1.9063237,0.148435922 L2.22624434,0.152941176 L3.42081448,0.152941176 L3.64124876,0.15093673 L4.10629247,0.134899213 Z M0.00359481541,1.31145243 L0.131418141,1.32144717 L0.326218837,1.32852614 L0.43438914,1.32941176 L1.07779564,1.37729516 L1.06424979,1.73813344 L1.05972851,2.09954751 L0.982056943,3.22420192 L1.22642299,2.99375235 C1.304664,2.92246067 1.39819163,2.84468805 1.52256522,2.76172877 L1.58887654,2.86723505 C1.6258373,2.93100937 1.66811091,3.01416416 1.71392086,3.12951844 L0.966342078,3.7875658 C0.889773864,3.85218786 0.804619896,3.91867808 0.701563191,3.98590177 C0.631686139,3.85779384 0.544506744,3.74736661 0.445809366,3.58097128 C0.542062587,3.51971923 0.598051484,3.45069152 0.616596914,3.37255158 L0.623529412,3.31221719 L0.669833595,1.74751107 L0.256554032,1.74906351 C0.179423002,1.7481151 0.110463104,1.74488598 0.0464822245,1.73642982 L-0.0461538462,1.71945701 L-0.0461538462,1.35746606 L0.00359481541,1.31145243 Z M3.74065067,0.806151172 C3.87496059,0.842781151 4.02121639,0.891533085 4.19553163,1.02811081 L4.16811618,1.07036349 C4.14868575,1.10455665 4.1208798,1.15802976 4.0856366,1.22934164 L4.00551188,1.39532344 C3.89710374,1.62418507 3.80076284,1.83493079 3.65356752,2.05033103 L3.47819517,1.96749637 C3.41867638,1.93893359 3.35677484,1.90672113 3.28852633,1.86276369 C3.43251302,1.55559207 3.54568413,1.275553 3.62805702,1.02273881 L3.68406229,0.838234275 L3.74065067,0.806151172 Z M1.875991,0.847739445 L1.94148208,0.86574137 C2.14740067,1.26546569 2.29291426,1.58074512 2.34943676,1.87183968 L2.07822725,1.96603184 C2.03162037,1.98041833 1.98261788,1.99350698 1.92868032,2.00433518 C1.80903477,1.60950486 1.67770805,1.29312686 1.56139842,0.987466841 C1.63927642,0.964103443 1.71182637,0.935608699 1.77907966,0.901995789 L1.875991,0.847739445 Z M0.663031135,-0.0354563668 C0.810628254,0.0875412325 1.02339068,0.318540443 1.29256987,0.726185127 L1.13351075,0.835818842 C1.077586,0.873262989 1.0158098,0.911335776 0.939342861,0.949224407 C0.808430888,0.758806991 0.611083706,0.531558722 0.350543525,0.199837751 L0.425839901,0.13443939 L0.600848465,-0.0326356976 L0.663031135,-0.0354563668 Z" id="评备份"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <span class="label">评价/提议</span>
    </el-button>

    <el-button type="text" @click.stop="showComment" v-if="hasAuth('BToSqMDC7NCJ') && isModuleEntry() && isShowComment && getCommentWhiteList()">
      <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 1px;">
        <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="用户评价" transform="translate(-345.000000, -94.000000)" fill="#6d2ef8">
                <g id="评价" transform="translate(345.000000, 94.000000)">
                    <path d="M6.45350293,0.23301294 C6.62539684,0.31265024 6.76345138,0.450704784 6.84308868,0.62259869 L8.11634634,3.37087408 L11.1235698,3.73255027 C11.5622364,3.78530833 11.8750771,4.18368673 11.8223191,4.62235334 C11.7996976,4.81044344 11.7110611,4.98440231 11.5721896,5.11326002 L9.7046794,6.84486502 L9.61085973,6.84524887 L9.31113396,6.84103809 L9.02073952,6.82842363 C8.87142082,6.81964018 8.73034207,6.85574369 8.61026156,6.92395331 C8.56846513,6.88437523 8.52871747,6.84886882 8.4908511,6.81731352 C8.19744076,6.5728049 7.76599698,6.59237563 7.49592839,6.86244422 C7.41405699,6.94431562 7.34538914,7.00807862 7.29195433,7.05260763 C6.99347791,7.30133798 6.9437416,7.7313414 7.1577626,8.03904846 C6.86271889,8.13435365 6.64615385,8.41127103 6.64615385,8.74208145 L6.64615385,8.74208145 L6.64615385,9.1040724 L6.6518111,9.19612434 L6.67053711,9.29324939 C6.74547458,9.57732743 6.98505977,9.79194231 7.27623838,9.83478128 L7.27623838,9.83478128 L7.31630769,9.83815385 L7.3156794,10.190865 L6.11720661,9.52359351 L3.47172379,10.9985929 C3.08582464,11.2137525 2.59857025,11.0753408 2.38341066,10.6894416 C2.29115519,10.523977 2.26061315,10.3311421 2.29722192,10.1452674 L2.88253058,7.17346381 L0.662223619,5.11326002 C0.338345286,4.81273609 0.3194128,4.30655805 0.619936727,3.98267972 C0.748794439,3.84380818 0.922753312,3.7551717 1.11084341,3.73255027 L4.11806688,3.37087408 L5.39132454,0.62259869 C5.57705587,0.221705091 6.05260934,0.0472816096 6.45350293,0.23301294 Z" id="形状结合"></path>
                    <g id="编组-7" transform="translate(7.384615, 7.384615)" fill-rule="nonzero">
                        <path d="M4.10629247,0.134899213 L4.15475113,0.180995475 L4.10629247,0.57098314 L3.6653319,0.551685312 C3.5507742,0.545833857 3.4260318,0.538086093 3.2928239,0.526733473 L3.08687783,0.50678733 L3.04072398,2.19819005 L3.85815666,2.19789345 C3.9692217,2.19838842 4.07753584,2.20073059 4.18738512,2.20896586 L4.35384615,2.22624434 L4.30481331,2.61619971 C4.16080975,2.60719949 3.99297831,2.60156916 3.80135818,2.59931651 L3.60180995,2.59819005 L3.08687783,2.5520362 L3.08717312,3.87012516 C3.08667728,3.97043154 3.08433424,4.06800849 3.07609965,4.16717211 L3.05882353,4.31764706 L2.61454343,4.26906742 C2.62256044,4.11674432 2.62790399,3.97247722 2.63057558,3.83627133 L2.63257919,3.63800905 L2.67873303,2.59819005 L2.06334842,2.59819005 C1.90115319,2.59819005 1.74575807,2.60156788 1.57648072,2.58888801 L1.40180995,2.57013575 L1.4508428,2.18018038 C1.57889219,2.18818347 1.71231809,2.19352007 1.85111811,2.19618857 L2.06334842,2.19819005 L2.63257919,2.24434389 L2.67873303,0.552941176 L2.15955165,0.553049473 C1.95592451,0.552064821 1.78695001,0.548261904 1.64659792,0.535875841 L1.54660633,0.524886878 L1.59547043,0.134899213 L1.9063237,0.148435922 L2.22624434,0.152941176 L3.42081448,0.152941176 L3.64124876,0.15093673 L4.10629247,0.134899213 Z M0.00359481541,1.31145243 L0.131418141,1.32144717 L0.326218837,1.32852614 L0.43438914,1.32941176 L1.07779564,1.37729516 L1.06424979,1.73813344 L1.05972851,2.09954751 L0.982056943,3.22420192 L1.22642299,2.99375235 C1.304664,2.92246067 1.39819163,2.84468805 1.52256522,2.76172877 L1.58887654,2.86723505 C1.6258373,2.93100937 1.66811091,3.01416416 1.71392086,3.12951844 L0.966342078,3.7875658 C0.889773864,3.85218786 0.804619896,3.91867808 0.701563191,3.98590177 C0.631686139,3.85779384 0.544506744,3.74736661 0.445809366,3.58097128 C0.542062587,3.51971923 0.598051484,3.45069152 0.616596914,3.37255158 L0.623529412,3.31221719 L0.669833595,1.74751107 L0.256554032,1.74906351 C0.179423002,1.7481151 0.110463104,1.74488598 0.0464822245,1.73642982 L-0.0461538462,1.71945701 L-0.0461538462,1.35746606 L0.00359481541,1.31145243 Z M3.74065067,0.806151172 C3.87496059,0.842781151 4.02121639,0.891533085 4.19553163,1.02811081 L4.16811618,1.07036349 C4.14868575,1.10455665 4.1208798,1.15802976 4.0856366,1.22934164 L4.00551188,1.39532344 C3.89710374,1.62418507 3.80076284,1.83493079 3.65356752,2.05033103 L3.47819517,1.96749637 C3.41867638,1.93893359 3.35677484,1.90672113 3.28852633,1.86276369 C3.43251302,1.55559207 3.54568413,1.275553 3.62805702,1.02273881 L3.68406229,0.838234275 L3.74065067,0.806151172 Z M1.875991,0.847739445 L1.94148208,0.86574137 C2.14740067,1.26546569 2.29291426,1.58074512 2.34943676,1.87183968 L2.07822725,1.96603184 C2.03162037,1.98041833 1.98261788,1.99350698 1.92868032,2.00433518 C1.80903477,1.60950486 1.67770805,1.29312686 1.56139842,0.987466841 C1.63927642,0.964103443 1.71182637,0.935608699 1.77907966,0.901995789 L1.875991,0.847739445 Z M0.663031135,-0.0354563668 C0.810628254,0.0875412325 1.02339068,0.318540443 1.29256987,0.726185127 L1.13351075,0.835818842 C1.077586,0.873262989 1.0158098,0.911335776 0.939342861,0.949224407 C0.808430888,0.758806991 0.611083706,0.531558722 0.350543525,0.199837751 L0.425839901,0.13443939 L0.600848465,-0.0326356976 L0.663031135,-0.0354563668 Z" id="评备份"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <span class="label">评价/反馈</span>
    </el-button>

    <el-button v-if="hasAuth('BToSqMXdjKfj') && isModuleEntry() && isShowVideo && videoStatus" type="text" @click.stop="showVideo">
      <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="终版" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="编组-32" transform="translate(-378.000000, -91.000000)">
                  <g id="视频教程" transform="translate(378.000000, 91.000000)">
                      <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="12" height="12"></rect>
                      <g fill="#6d2ef8" fill-rule="nonzero" id="形状结合">
                          <path d="M11.4814889,0.00795680733 C11.7576312,0.00795680733 11.9814889,0.231814432 11.9814889,0.507956807 L11.9814889,0.507956807 L11.9814889,11.4824891 C11.9814889,11.7586314 11.7576312,11.9824891 11.4814889,11.9824891 L11.4814889,11.9824891 L0.506971537,11.9824891 C0.230829162,11.9824891 0.00697153662,11.7586314 0.00697153662,11.4824891 L0.00697153662,11.4824891 L0.00697153662,0.507956807 C0.00697153662,0.231814432 0.230829162,0.00795680733 0.506971537,0.00795680733 L0.506971537,0.00795680733 Z M2.19804936,9.7913963 L1.12798567,9.7913963 L1.12798567,10.86146 L2.19804936,10.86146 L2.19804936,9.7913963 Z M10.9114252,9.7913963 L9.81587878,9.7913963 L9.81587878,10.86146 L10.9114252,10.86146 L10.9114252,9.7913963 Z M2.19804936,7.65126891 L1.12798567,7.65126891 L1.12798567,8.69586485 L2.19804936,8.69586485 L2.19804936,7.65126891 Z M10.9114252,7.65126891 L9.81587878,7.65126891 L9.81587878,8.69586485 L10.9114252,8.69586485 L10.9114252,7.65126891 Z M4.1,3.5 L4.1,8.5 L8.1,6 L4.1,3.5 Z M2.19804936,5.4347084 L1.12798567,5.4347084 L1.12798567,6.50477209 L2.19804936,6.50477209 L2.19804936,5.4347084 Z M10.9114252,5.4347084 L9.81587878,5.4347084 L9.81587878,6.50477209 L10.9114252,6.50477209 L10.9114252,5.4347084 Z M2.19804936,3.26911326 L1.12798567,3.26911326 L1.12798567,4.33917695 L2.19804936,4.33917695 L2.19804936,3.26911326 Z M10.9114252,3.26911326 L9.81587878,3.26911326 L9.81587878,4.33917695 L10.9114252,4.33917695 L10.9114252,3.26911326 Z M2.19804936,1.10350318 L1.12798567,1.10350318 L1.12798567,2.17356688 L2.19804936,2.17356688 L2.19804936,1.10350318 Z M10.9114252,1.10350318 L9.81587878,1.10350318 L9.81587878,2.17356688 L10.9114252,2.17356688 L10.9114252,1.10350318 Z"></path>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
      <span class="label">视频教程</span>
    </el-button>

    <el-button v-if="hasAuth('BToSqM-CW7RV') && isModuleEntry() && noticeStatus && showNotice" type="text" @click.stop="handleNotice">
      <svg t="1702534739817" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2105" width="12" height="12">
        <path d="M553.130667 68.266667a44.544 44.544 0 0 0-47.36 5.973333l-256 213.162667-204.288-0.853334a44.373333 44.373333 0 0 0-44.544 44.458667L0 687.189333a44.544 44.544 0 0 0 44.544 44.629334h206.506667l254.72 212.394666a44.629333 44.629333 0 0 0 73.045333-34.304V108.544a44.544 44.544 0 0 0-25.685333-40.362667z m172.629333 222.549333a44.373333 44.373333 0 0 0-58.709333 20.906667 44.8 44.8 0 0 0 20.309333 59.392c2.816 1.450667 69.546667 36.181333 69.546667 134.826666 0 105.472-62.378667 140.373333-64.426667 141.568a44.544 44.544 0 0 0 39.765333 79.701334c4.693333-2.389333 113.664-58.794667 113.664-221.269334 0-156.757333-115.2-212.821333-120.149333-215.125333z m138.581333-130.730667a44.373333 44.373333 0 0 0-48.213333 74.837334c4.778667 3.157333 118.869333 80.896 118.869333 274.346666 0 193.877333-109.397333 271.616-113.749333 274.602667a44.544 44.544 0 1 0 49.408 74.069333C876.885333 853.76 1024 752.981333 1024 509.184c0-244.138667-153.088-344.917333-159.573333-349.098667z" fill="#7653D6" p-id="2106">
        </path>
      </svg>
      <span class="label">升级通知</span>
    </el-button>

    <kye-dialog
      ref="dialog"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :visible.sync="dialogOptions.visible"
      :view.sync="dialogOptions.view">
      <component
        :videoId="videoId"
        :is="dialogOptions.view">
      </component>
    </kye-dialog>

    <el-dialog
      ref="videoDialog"
      title="视频教程提示"
      class="video-dialog"
      width="420px"
      :close-on-click-modal="false"
      :visible.sync="videoVisible">
      <span class="video-dialog-content"><i class="video-dialog-icon el-icon-warning"></i>{{ videoMessage }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="gotoVideo">去观看</el-button>
        <el-button @click="videoVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { REST, ENV } from '@/public/config'
import { getToken } from '@/public/utils/token'
import { md5Http, getMenuIdByRoute, random } from '@/public/utils/common'
import { AXIOS } from '@/public/utils/common-api'

const MSG = '您可以通过视频更快了解这个模块的功能操作'

export default {
  name: 'user-access',
  props: {
    showAccess: {
      type: Boolean,
      default: true
    },
    isShowComment: {
      type: Boolean,
      default: true
    },
    isShowVideo: {
      type: Boolean,
      default: true
    },
    showNotice: {
      type: Boolean,
      default: true
    },
  },
  components: {
    Comment: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/comment'),
    // HrVideoTutorial: () => import(/* webpackChunkName: "public-helpers" */ '@/layout/components/hr-video-tutorial')
  },
  data () {
    return {
      accessTotal: '0',
      accessPercent: '0',
      status: true,
      // scoreTotal: 0,
      videoStatus: false,
      videoVisible: false,
      videoMessage: MSG,
      videoId: '',
      noticeStatus: false,
      dialogOptions: this.getDialogOptions()
    }
  },
  computed: {
    menuId () {
      const menu = getMenuIdByRoute(this.$store, this.$route)
      return menu && menu.id
    },
    isShowAccess () {
      return this.showAccess && this.$route.path !== '/'
    }
  },
  activated () {
    this.getAccessStatistics()
  },
  mounted () {
    // this.getAccessStatistics()
    this.getVideoList()
    this.init()
  },
  methods: {
    init () {
      setTimeout(() => {
        // 延迟显示升级通知按钮
        this.getUpgradeLog()
      }, 1000)
    },
    getDialogOptions () {
      return { title: '', visible: false, view: '', width: null, helper: '', url: '' }
    },
    hasAuth (code) {
      return this.$store.getters.permission.menus.includes(code)
    },
    show () {
      if (ENV === 'prd') {
        return this.hasAuth('BTo8Ta3jxsrO')
      } else {
        return true
      }
    },
    // 只有模块首页才显示统计
    isModuleEntry () {
      return this.$route.meta.moduleEntry || this.$route.path === this.$route.meta.tag
    },
    handleClick (e) {
      e.stopPropagation()
      let employeeNumber = window.__ERPUSER__.employeeNumber
      let auth = this.$store.getters.permission.menus.includes('BTo5rXUhbGoj')
      if (String(employeeNumber) === '000888' || auth) {
          this.getAccessStatistics()
          this.$router.push({
            path: '/mcs/access-statistic',
            query: {
              menuId: this.menuId
            }
          })
      } else {
        this.$message.warning('您尚未开通此功能，如有需要，请录权限申请。')
      }
      // 跳路由,
    },
    getAccessStatistics () {
      let token = getToken()
      let now = Date.now()
      if (this.show() && this.isModuleEntry()) {
        let data = {menuId: this.menuId, source: 'ERP'}
        let vm = this
        axios({
          method: 'post',
          url: `${REST}?mcs.menu.userAccess.detail.pc.ingressMetrics`,
          data,
          headers: {
            format: 'JSON',
            method: 'mcs.menu.userAccess.detail.pc.ingressMetrics',
            appkey: '50178',
            token,
            'X-menu-id': '2820215716730110',
            timestamp: now,
            sign: md5Http(token, now, data)
          }
        }).then(function(res) {
          if (res.data.code !== 0) {
            vm.status = false
            return
          }
          vm.status = true
          let data = res.data.data
          if (data.accessTotal && data.accessTotal >= 10000) {
            data.accessTotal = '10000+'
          }
          vm.accessTotal = data.accessTotal
          vm.accessPercent = data.accessPercent > 100 ? 100 : data.accessPercent
        }).catch(function(e) {
          // 接口异常时不显示统计组件
          vm.status = false
          console.log(e)
        })
      }
    },
    /**
     * 显示评论弹窗
     */
    showComment () {
      // this.$bus.$emit('HELPER_COMMET')
      this.appentToParent()
      this.showDialog({
        title: this.getCommentWhiteList() ? '评价/反馈' : '评价/提议',
        width: 4,
        view: 'Comment',
      })
    },
    getCommentWhiteList () {
      const lookup = window.__ERPLOOKUP__ ? window.__ERPLOOKUP__.find(x => x.code === 'sys_comment_tooltips_white') : null
      return lookup && lookup.value && lookup.value.length
    },
    /**
     * 更换弹窗父级元素
     */
    appentToParent(ref = 'dialog') {
      document.body.querySelector('.el-main').children[0].appendChild(this.$refs[ref].$el)
    },
    showVideo () {
      new Promise(window.__ERP_REMOTE_IMPORT__('hr_train/VideoTutorial')).then(module => {
        console.log('module', module)
        const VideoTutorial = module.default
        const VideoTutorialClass = Vue.extend(VideoTutorial)
        const instance = new VideoTutorialClass({
          parent: this,
          propsData: {
            title: '视频教程',
            videoId: this.videoId,
            visible: true,
          }
        })
        instance.$mount()
        document.body.querySelector('.el-main').children[0].appendChild(instance.$el)
      }).catch(e => {
        console.log(e)
      })
      // this.appentToParent()
      // this.showDialog({
      //   title: '视频教程',
      //   width: '75%',
      //   view: 'HrVideoTutorial',
      // })
    },
    showDialog (opt) {
      this.dialogOptions.title = opt.title
      this.dialogOptions.width = opt.width || 6
      this.dialogOptions.view = opt.view
      this.dialogOptions.visible = true
    },
    /**
     * 获取菜单是否有视频教程
     * 获取菜单是否需要提示观看视频
     */
    getVideoList () {
      if (this.isModuleEntry() && this.isShowVideo) {
        this.$http('hr.trainingNew.videoMenuRela.checkVideoStatus', {
          menuType: 1,
          menuId: this.menuId,
          time: random()
        }, { ...AXIOS, log: false, cancel: true }).then(data => {
          if (data) {
            this.videoStatus = data.show
            this.videoId = data.videoId
            if (data.show && data.remind) {
              this.videoMessage = data.message || MSG
              this.appentToParent('videoDialog')
              this.videoVisible = true
            }
          }
        }).catch(e => {
          this.videoStatus = false
        })
      }
    },
    gotoVideo () {
      this.videoVisible = false
      this.showVideo()
    },
    /**
     * 获取当前模块升级日志
     */
    getUpgradeLog () {
      if (this.isModuleEntry()) {
        this.$http('system.upgradeLog.detail', { moduleId: this.menuId, time: random() }, { ...AXIOS, log: false, cancel: true }).then(data => {
          if (data && data.id) {
            this.noticeStatus = true
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    handleNotice (val) {
      this.$router.push({
        path: '/ams/menu-upgrade-log',
        query: {
          menuId: this.menuId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .key-user-access-wrap{
    display: inline;
    vertical-align: middle;
    font-size: 0;
    svg,span{
      vertical-align: middle;
    }
    .label{
      margin-left: 0px;
    }
    .el-button--text{
      margin-left: 8px;
    }
  }
  .kye-user-access {
    display: inline;
    font-size: 12px;
    color: var(--g-color-primary);
    cursor: pointer;
  }
  .custom-tooltip{
    padding: 3px 0;
  }
  .menu-wrap {
    display: inline-block;
    margin-left: 16px;
    cursor: pointer;
    &-title {
      color: var(--g-color-primary);
      font-size: 12px;
      font-weight: normal;
    }
    .layout-caretdown {
      margin-left: 4px !important;
    }
    .el-dropdown-link {
      // display: flex;
      // align-items: center;
    }
  }
  .video-dialog {
    /deep/ .el-dialog__header {
      border: 0;
    }
    /deep/ .el-dialog__footer {
      border: 0;
    }
    /deep/ .el-dialog__body {
      padding: 16px;
    }
    &-content {
      display: flex;
      align-items: center;
      height: 86px;
    }
    &-icon {
      font-size: 20px !important;
      color: #ffc300;
      margin-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/user-access.vue